import React, { useEffect, useRef, useState } from 'react';
import { X, Heart, Send, Eye, Radio } from 'lucide-react';
import { IMG } from '../mock';

const FAKE = [
  { u: 'Sarah', t: 'You look great! 🔥' },
  { u: 'David', t: 'Where is this?' },
  { u: 'Anna', t: 'Joining now 👋' },
  { u: 'Michael', t: 'Amazing stream!' },
  { u: 'Lisa', t: 'Hi from London!' },
  { u: 'Chris', t: 'Turn the camera around' },
];

export default function LiveScreen({ onClose }) {
  const videoRef = useRef(null);
  const [noCam, setNoCam] = useState(false);
  const [viewers, setViewers] = useState(1);
  const [hearts, setHearts] = useState([]);
  const [comments, setComments] = useState([]);
  const [text, setText] = useState('');

  useEffect(() => {
    let stream;
    if (navigator.mediaDevices?.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false })
        .then((s) => { stream = s; if (videoRef.current) videoRef.current.srcObject = s; })
        .catch(() => setNoCam(true));
    } else setNoCam(true);
    return () => stream && stream.getTracks().forEach((t) => t.stop());
  }, []);

  useEffect(() => {
    const v = setInterval(() => setViewers((n) => n + Math.floor(Math.random() * 4)), 1500);
    const c = setInterval(() => {
      const f = FAKE[Math.floor(Math.random() * FAKE.length)];
      setComments((prev) => [...prev.slice(-6), { ...f, id: Date.now() + Math.random() }]);
    }, 2200);
    return () => { clearInterval(v); clearInterval(c); };
  }, []);

  const addHeart = () => setHearts((h) => [...h, { id: Date.now() + Math.random(), x: 10 + Math.random() * 30 }]);
  const sendComment = () => {
    if (!text.trim()) return;
    setComments((prev) => [...prev.slice(-6), { u: 'You', t: text.trim(), id: Date.now() }]);
    setText('');
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black flex flex-col max-w-[440px] mx-auto overflow-hidden">
      {noCam ? (
        <img src={IMG.P.selfie} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" />
      ) : (
        <video ref={videoRef} autoPlay playsInline muted className="absolute inset-0 w-full h-full object-cover" />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/70" />

      <div className="relative flex items-center gap-2 px-4 pt-4">
        <span className="flex items-center gap-1.5 bg-[#f43f5e] px-2.5 py-1 rounded-md">
          <span className="w-2 h-2 rounded-full bg-white live-dot" />
          <span className="text-[12px] font-bold text-white">LIVE</span>
        </span>
        <span className="flex items-center gap-1 bg-black/50 px-2.5 py-1 rounded-md text-[12px] font-semibold text-white">
          <Eye size={13} /> {viewers.toLocaleString()}
        </span>
        <button onClick={onClose} className="ml-auto w-9 h-9 rounded-full bg-black/50 flex items-center justify-center">
          <X size={20} className="text-white" />
        </button>
      </div>

      {noCam && (
        <div className="relative mt-3 mx-auto flex items-center gap-1.5 bg-black/50 px-3 py-1.5 rounded-full text-[11px] text-[#c4ccd8]">
          <Radio size={12} className="text-[#2f8bff]" /> Camera preview unavailable — showing demo
        </div>
      )}

      <div className="relative mt-auto">
        <div className="px-4 pb-2 space-y-1.5 max-h-52 overflow-hidden">
          {comments.map((c) => (
            <div key={c.id} className="animate-fade-up">
              <span className="text-[13px] text-white"><span className="font-semibold text-[#8fd0ff]">{c.u}</span> {c.t}</span>
            </div>
          ))}
        </div>

        <div className="relative flex items-center gap-2 px-4 pb-6 pt-2">
          <div className="flex-1 flex items-center bg-white/12 rounded-full px-4 py-2.5 ring-1 ring-white/15">
            <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && sendComment()} placeholder="Add a comment..." className="flex-1 bg-transparent text-[14px] text-white placeholder:text-white/60 outline-none" />
            <button onClick={sendComment}><Send size={17} className="text-white" /></button>
          </div>
          <button onClick={addHeart} className="w-11 h-11 rounded-full bg-white/12 ring-1 ring-white/15 flex items-center justify-center active:scale-90 transition-transform">
            <Heart size={20} className="text-[#f43f5e] fill-[#f43f5e]" />
          </button>
        </div>

        {hearts.map((h) => (
          <Heart key={h.id} size={26} onAnimationEnd={() => setHearts((prev) => prev.filter((x) => x.id !== h.id))}
            className="absolute bottom-20 text-[#f43f5e] fill-[#f43f5e] float-heart" style={{ right: `${h.x}px` }} />
        ))}
      </div>
    </div>
  );
}
